module.exports = __webpack_public_path__ + "media/application/images/ipad-small@2x-4efa8c4299a04b9300c1009852caeb1f.png";